import { mapActions, mapGetters } from 'vuex'

import PublicPageWrapper from '@/components/PublicPageWrapper'
import MainButton from '@/components/MainButton/index'
import ResponseDialog from '@/components/ResponseDialog/index'
import Logo from '@/assets/the-long-ball-logo.svg'

export default {
  name: 'change-password',
  components: {
    PublicPageWrapper,
    MainButton,
    ResponseDialog
  },
  data: () => ({
    password: '',
    confirmPassword: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'Password must be at least 8 characters'
    ],
    loading: false,
    responseDialog: false,
    responseDialogMessage: '',
    tokenQuery: '',
    changePassword: false,
    Logo
  }),
  computed: {
    ...mapGetters('changePassword', {
      tokenVerfyResponse: 'CHANGE_PASSWORD_TOKEN_CHECKER_RESPONSE',
      changePasswordResponse: 'CHANGE_PASSWORD_RESPONSE'
    })
  },
  methods: {
    ...mapActions('changePassword', {
      verifyToken: 'VERIFY_CHANGE_PASSWORD_TOKEN',
      postChangePassword: 'CHANGE_PASSWORD'
    }),
    confirmPasswordRules(v) {
      return v === this.password || `Doesn't match the entered password`
    },
    submitPassword() {
      if (this.$refs.changePassword.validate()) {
        if (this.password && this.password === this.confirmPassword) {
          this.loading = true

          this.postChangePassword({
            password: this.password,
            token: this.tokenQuery
          }).then(() => {
            const { message } = this.changePasswordResponse
            this.responseDialogMessage = message

            this.responseDialog = true
            this.loading = false
          })
        }
      }
    },
    responseDialogClick() {
      this.password = ''
      this.confirmPassword = ''
      this.responseDialog = false
      this.routeToLogin()
    },
    routeToLogin() {
      this.$router.push({ path: '/login' })
    }
  },
  created() {
    this.tokenQuery = this.$router.currentRoute.query._a

    if (!this.tokenQuery) {
      this.routeToLogin()
    } else {
      this.verifyToken({ token: this.tokenQuery }).then(() => {
        const { success } = this.tokenVerfyResponse
        if (!success) {
          this.routeToLogin()
        }
      })
    }
  }
}
